export default __webpack_public_path__ + "static/media/svg-1.b8e41778.svg";